import { AnalyticsEvent } from 'Shared/services/analytics/config';
import {
  ANALYTICS_EVENT_ATTRIBUTES,
  ANALYTICS_EVENT_NAMES,
  ANALYTICS_EVENT_TYPE,
  ANALYTICS_REFERRER_TYPES,
} from 'Shared/services/analytics/constants';
import { GA4_EVENT_CATEGORY, trackEventConditionally } from "Shared/services/analytics/services/thresholdManager";

export type ContactFormSubmitEndEvent = {
  [ANALYTICS_EVENT_ATTRIBUTES.sub_type] : string,
  [ANALYTICS_EVENT_ATTRIBUTES.referrer] : ANALYTICS_REFERRER_TYPES,
  [ANALYTICS_EVENT_ATTRIBUTES.survey_id]: string,
}

/**
 * Allows tracking end of contact us form submission.
 * @param contactFormSubmitEndEvent
 * @returns void
 */
export const analyticsTrackContactFormSubmitEnd = (contactFormSubmitEndEvent: ContactFormSubmitEndEvent): void => {
  const event: AnalyticsEvent = {
    event     : ANALYTICS_EVENT_NAMES.end,
    attributes: {
      [ANALYTICS_EVENT_ATTRIBUTES.type]: ANALYTICS_EVENT_TYPE.contact_support,
      ...contactFormSubmitEndEvent
    }
  };

  trackEventConditionally(GA4_EVENT_CATEGORY.other, [event]);
};